import {
  createContext,
  useCallback,
  useContext,
  useMemo,
  useState,
} from "react";

import {
  getProfileById,
  createProfile,
  getProfileList,
  deleteProfileById,
  updateProfileById,
} from "./queries";

const ProfileContext = createContext({});

export const useProfileContext = () => useContext(ProfileContext);

export const ProfileProvider = ({ ...props }) => {
  const [profileList, setProfileList] = useState([]);
  const [profilePerId, setProfilePerId] = useState({});
  const profileListGetter = useCallback(async () => {
    try {
      if (profileList.length === 0) {
        setProfileList(await getProfileList());
      }
    } catch (e) {
      console.error("profileListGetter", e);
      throw e;
    }
  }, [profileList]);

  const profileCreate = useCallback(async (data) => {
    try {
      const profile = await createProfile(data);
      setProfileList((old) => [...old, profile]);
    } catch (e) {
      console.error("profileCreate", e);
      throw e;
    }
  }, []);

  const profileUpdateById = useCallback(async (id, data) => {
    try {
      const updatedProfile = await updateProfileById(id, data);
      setProfileList((old) =>
        old.map((elm) => (elm.id === updatedProfile.id ? updatedProfile : elm))
      );
      setProfilePerId(updatedProfile);
    } catch (e) {
      console.error("profileUpdateById", e);
      throw e;
    }
  }, []);

  const profileByIdGetter = useCallback(async (id) => {
    try {
      id && setProfilePerId(await getProfileById(id));
    } catch (e) {
      console.error("profileByIdGetter", e);
      throw e;
    }
  }, []);

  const profileDeleteById = useCallback(
    async (id) => {
      try {
        await deleteProfileById(id);
        setProfileList((old) => old.filter((row) => row.id !== id));
      } catch (e) {
        console.error("profileDeleteById", e);
        throw e;
      }
    },
    [setProfileList]
  );
  const values = useMemo(
    () => ({
      profileList,
      profileByIdGetter,
      profileListGetter,
      profileDeleteById,
      profilePerId,
      profileCreate,
      profileUpdateById,
      setProfilePerId,
    }),
    [
      profileList,
      profileByIdGetter,
      profileListGetter,
      profileDeleteById,
      profileCreate,
      profileUpdateById,
      profilePerId,
      setProfilePerId,
    ]
  );
  return <ProfileContext.Provider value={values} {...props} />;
};
